/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1405
 */

module.exports = function (e) {
  this.wrapped = e
}
